import ExaminationEventSummary from './ExaminationEventSummary';

export default ExaminationEventSummary;
